import { hookstate } from '@hookstate/core'

type RolesPermissionsState = {
  permissions: string[]
}

const initialState: RolesPermissionsState = {
  permissions: []
}

const RolesPermissionsGlobalState = hookstate(initialState)

export { RolesPermissionsGlobalState }
